module.exports = __webpack_public_path__ + "static/media/baseball-ball.4aa9849d.svg";